import React, { useRef, useState, useEffect } from "react"
import { FiArchive, FiArrowDown, FiCheck, FiMoreVertical, FiPause, FiPlay, FiPlus, FiRepeat, FiTrash2, FiUsers, FiVolumeX, FiX } from "react-icons/fi"
import clx from "classnames"
import { MentionRegex } from "../../../../utils/helper";
import { Send } from "./send";
import { useModal } from "../../../../stores/useModal";
import WaveSurfer from 'wavesurfer.js'
import song from '../../../../assets/audio/song.wav'
import { EmojiPicker } from "../../messsenger/content/emojipicker";

export const WaveformNeon = ({ audio }) => {
    if(!audio) audio = song;

    const containerRef = useRef()
    useEffect(() => {
      const waveSurfer = WaveSurfer.create({
        container: containerRef.current,
         container: "#waveform",
        waveColor: "rgb(200, 0, 200)",
        progressColor: "rgb(100, 0, 100)",
        height: 45,
        barWidth: 2, 
        barHeight: 1,
        barGap: 4,
        barRadius: 15
      })
      waveSurfer.load(audio)
  
      return () => {
        waveSurfer.destroy()
      }
    }, [audio])
  
    return <div ref={containerRef} />
  }
  

export const Conversations = ({
    messages,
    setMessages,
    profile,
    setProfile,
    handle,
    isToday,
    posted,
    setPosted
}) => {
    const {open} = useModal(state=>state)

    const openImage = () => {
    open({type:'phone-call', values:{} })

    }

    return (
        <React.Fragment>
            <div className={clx({'hidden':profile})} >
                    {/** MESSAGES **/}
                    <ul className="lg:grid gap-6 lg:p-6">
                        {messages.map((message,i)=>{

                        const post =  ( 
                                <li key={`user-messages-${i}`} className="group relative">

                                {/** AUDIOS **/}
                                {message.messages?.map((message,key)=>{

                                    if(message.type == 'audio'){
                                        return (
                                        <React.Fragment>
                                            <div className="flex items-center mx-14">
                                                    <div
                                                    className="w-full bg-gray-100 dark:bg-[#1e2126] p-3 rounded-md my-2 flex justify-between gap-3"
                                                    >
                                                    <div>
                                                        <div
                                                        className="relative group rounded-full h-20 w-20 overflow-hidden"
                                                        >
                                                        <div
                                                            id="controls"
                                                            className="absolute z-20 flex items-center justify-center left-0 right-0 top-0 bottom-0"
                                                        >
                                                            <div 
                                                            onClick={()=>waveSurfer.play()}
                                                            className="play">
                                                            <FiPlay size={23}
                                                                className="stroke-none fill-white"
                                                            />
                                                            </div>
                                                            <div className="pause hidden">
                                                            <FiPause size={23}
                                                                className="stroke-none fill-white"
                                                            />
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="hidden- opacity-50 group-hover:opacity-70 group-hover:block absolute left-0 right-0 top-0 bottom-0 bg-black rounded-full"
                                                        ></div>
                                                        <img
                                                            src="/images/avatars/Vector-1.png"
                                                            className="h-full object-cover rounded-full"
                                                        />
                                                        </div>
                                                    </div>
                                                    <div className="relative w-full">
                                                        <div className="flex gap-3 justify-between mb-2">
                                                        <div className="flex gap-2 items-center">
                                                            <p className="font-semibold">Jonth - WHAT Jump Up NCS</p>
                                                            <p className="text-gray-500 text-sm">KIVI</p>
                                                        </div>
                                                        <div>
                                                            <div className="text-xs flex gap-1">
                                                            <div>
                                                                <div
                                                                style={{
                                                                    display: "none",
                                                                    margin:" 1rem 0",
                                                                    gap: "1rem"
                                                                }}
                                                                
                                                                >
                                                                <button>Play/pause</button>

                                                                <label>
                                                                    Playback rate: <span id="rate">1.00</span>x
                                                                </label>

                                                                <label>
                                                                    0.25x
                                                                    <input
                                                                    type="range"
                                                                    min="0"
                                                                    max="4"
                                                                    step="1"
                                                                    value="2"
                                                                    />
                                                                    4x
                                                                </label>

                                                                <label>
                                                                    <input type="checkbox" checked />
                                                                    Preserve pitch
                                                                </label>
                                                                </div>
                                                            </div>
                                                            <p className="mr-1 cursor-pointer">
                                                                <span className="speedy">1</span>x
                                                            </p>
                                                            <p className="">3:45</p>
                                                            <p className="">/</p>
                                                            <p className="text-gray-500">5:02</p>
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div id="waveform"></div>
                                                        <WaveformNeon audio={song} />
                                                    </div>

                                                    <div className="actions-file"></div>
                                                    </div>
                                            </div>
                                        </React.Fragment>
                                        )
                                    }
                                })}

                                {/** MESSAGE **/}
                                <div className="flex items-center">
                                    <div className="flex items-end gap-3 relative">
                                    <img
                                        src={message.user?.avatar}
                                        className="h-12 cursor-pointer object-contain rounded-full"
                                    />
                                    <div
                                        className="bg-gray-100 dark:bg-[#1e2126] px-3 py-2 rounded-md inline-block"
                                    >
                                        <div
                                        style={{color:message.user?.foreground}}
                                        className="font-medium">{message.user?.name}</div>
                                        {message.messages?.map((message,key)=>{


                                        if(typeof message == 'string'){
                                            return (
                                            <div className="text-sm my-2" key={`message-${key}`}>
                                                {message.split(' ').map((word,key)=>{
                                                
                                                if(word?.match(MentionRegex)) {
                                                
                                                var rand = Math.random() < 0.5;
                                                
                                                    if(rand){
                                                    return <span
                                                    className="text-purple-700 dark:text-purple-400 bg-purple-500/30 py-[1px] px-1 mx-[0px] mr-[4px] rounded-md cursor-pointer"
                                                    >{word}</span>
                                                    }
                                                    
                                                    return  <span
                                                    className="text-yellow-500 dark:text-[#F9C50B] bg-yellow-500/30 py-[1px] px-1 mx-[0px] mr-[4px] rounded-md cursor-pointer"
                                                    >{word}</span>
                                                }

                                                

                                                // <span className=" px-1 mx-[1px] "  >{word}</span>

                                                return `${word} `;

                                                }) }
                                            </div>
                                            )
                                        }
                                        return;
                                        })}
                                    </div>
                                    <div></div>
                                    <Actions 
                                    handle={handle}
                                    id={message.id} 
                                    />
                                    </div>
                                </div>

                                {/** IMAGES **/}
                                <div 
                                onClick={openImage}
                                className="flex ml-14 gap-3 my-2">
                                    {message.images?.map((image,key)=> {

                                    if(key<3){
                                        return (
                                        <img
                                            // @click="photo='/images/shared/Rectangle 6.png';preview=true"
                                            src={image.path}
                                            className="h-20 w-20 object-contain rounded-md cursor-pointer"
                                        />
                                        )
                                    }

                                    return (
                                        <div
                                            // @click="photo='/images/shared/Rectangle 5.png';preview=true"
                                            className="relative rounded-md overflow-hidden cursor-pointer"
                                        >
                                            <div
                                            className="text-white text-xl flex items-center justify-center z-[30] absolute left-0 right-0 top-0 bottom-0"
                                            >
                                            +{5}
                                            </div>
                                            <div
                                            className="absolute bg-black opacity-70 left-0 right-0 top-0 bottom-0"
                                            ></div>
                                            <img
                                            src={image.path}
                                            className="h-20 w-20 object-contain"
                                            />
                                        </div>
                                    )

                                    
                                    })}
                                </div>

                                <Options />

                                {/** FILES **/}
                                <ul className="-mt-2 mx-16 mr-14">
                                {message.messages?.map((message,key)=>{
                                        if(message.type == 'file'){
                                            return (
                                                <li
                                                className="relative p-2 bg-gray-100 dark:bg-zinc-800 dark:hover:bg-gray-800 rounded-md mb-2 cursor-pointer"
                                                >
                                                <div className="flex gap-2 flex justify-between items-center">
                                                    <div className="flex gap-2 items-center">
                                                    <div>
                                                        <div
                                                        className="w-10 h-10 bg-gray-50 bg-zinc-400 dark:bg-gray-500 rounded-md"
                                                        ></div>
                                                    </div>
                                                    <div>
                                                        <div className="dark:text-gray-200">
                                                        {message.path}
                                                        </div>
                                                        <div className="text-sm text-gray-500">
                                                        {message.size} {message.date}
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div
                                                    className="dark:bg-gray-600 rounded-full w-8 h-8 flex items-center justify-center">
                                                    <FiArrowDown size={23} className="h-5 w-5"/>
                                                    </div>
                                                </div>
                                                <div className="actions-file"></div>
                                                </li>
                                            )
                                        }

                                        })}
                                </ul>

                                {/** REACTIONS **/}
                                <ul className="flex gap-2 ml-16 mt-2">
                                    {message.reactions?.map((emoji,key)=>(
                                        <li
                                        onClick={()=>{
                                        handle(emoji.emoji, message.id)
                                        }}
                                        key={`emoji-${message.name}-${key}`}
                                        className={clx({'bg-gray-200 hover:bg-gray-300 dark:bg-[#333] dark:hover:bg-[#222]':emoji.voted},'bg-gray-100 hover:bg-gray-200 dark:bg-[#444] dark:hover:bg-[#333] p-1 rounded-full px-3 cursor-pointer')}
                                        >
                                        {emoji.emoji}
                                        {emoji.count>1 && emoji.count}
                                        </li>
                                    ))}
                                </ul>

                                </li>
                            )

                            if(isToday(message.date)){
                                if(!posted){
                                setPosted(message.id)
                                }
                            }

                            if(posted==message.id){
                                return (
                                <React.Fragment>
                                    <li className="mt-2 relative">
                                    <div
                                        className="cursor-pointer h-[1px] bg-gray-300 dark:bg-zinc-800 flex items-center justify-center"
                                    >
                                        <div
                                        className="dark:bg-zinc-800 bg-[#fcfcfc] rounded-full p-1 px-4 text-sm dark:text-gray-500"
                                        >
                                        TODAY
                                        </div>
                                    </div>
                                    </li>
                                    {post}
                                </React.Fragment>
                                )
                            }
                
                            if(message.deleted){
                                return (
                                <li key={`user-messages-${i}`} className="
                                -border dark:border-gray-700 rounded-md -mt-6 -mb-4
                                flex items-center justify-center dark:text-gray-600 gap-1" >
                                    <FiTrash2 size={17} /> 
                                    <p className="cursor-pointer">DELETED</p>
                                </li>
                                )
                            }

                            return post;

                        })}
                    </ul>

                  <Send />
            </div>
        </React.Fragment>
    )
}



export const Options = () => {
    const [status, setStatus] = useState(false);
  
    return (
      <React.Fragment>
        <div class="relative">
                  {/** OPTIONS COMPONENT **/}
                  <div
                    onClick={()=>setStatus(!status)}
                    className={clx({'hidden':!status})}
                   // @click.away="status=false"
                  >
                    <div className={status?'text-blue-400 ':'text-gray-400 '}>
                      <FiMoreVertical class="cursor-pointer"/>
                    </div>
                    <div
                      class="dropdown absolute right-0 top-6 z-10 divide-y dark:divide-zinc-600 border dark:border-zinc-600 bg-white dark:bg-zinc-700 rounded-lg w-32"
                    >
                      <ul class="py-2 text-sm text-gray-200">
                        <li
                          class="md:hidden cursor-pointer"
                          // </ul>@click="mobileDetail=!mobileDetail"
                          >
                          <div
                            class="block text-zinc-500 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-500 px-4 py-2 flex gap-1 items-center"
                          >
                            <FiUsers
                              class="h-4 text-zinc-600 dark:text-zinc-300"
                            />
                            <p>Detail</p>
                          </div>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="block text-zinc-500 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-500 px-4 py-2 flex gap-1 items-center"
                          >
                            <FiArchive
                              class="h-4 text-zinc-600 dark:text-zinc-300"
                            />
                            <p>Archive</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="block text-zinc-500 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-500 px-4 py-2 flex gap-1 items-center"
                          >
                            <FiVolumeX
                              class="h-4 text-zinc-600 dark:text-zinc-300"
                            />
                            <p>Muted</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="block text-zinc-500 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-500 px-4 py-2 flex gap-1 items-center"
                          >
                            <FiTrash2
                              class="h-4 text-zinc-600 dark:text-zinc-300"
                            />
                            <p>Delete</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            class="block text-zinc-500 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-500 px-4 py-2 flex gap-1 items-center"
                          >
                            <FiX
                              class="h-4 text-zinc-600 dark:text-zinc-300"
                            />
                            <p>Close</p>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
  
      </React.Fragment>
    )
}
  

export const Actions = ({id, handle}) => {
  const [status, setStatus] = useState(false);


  return (
    <div>
        {/** DROPDOWN **/}
        <div 
        onClick={()=>setStatus(!status)}
        // @click.away="status=false" 
        >
        <div className="absolute -right-2 -top-2 -bg-[#fcfcfc] -hover:bg-gray-200 cursor-pointer rounded-full flex items-center justify-center p-2">
            <FiMoreVertical className="stroke-gray-500"/>
        </div>
        <div
        className={clx({'hidden':!status}, `dropdown absolute right-0 top-10 bg-gray-50 border-gray-300 shadow-md 
        z-50 divide-y divide-gray-900 rounded-lg shadow- w-44 dark:bg-zinc-800` )}
        // :className="status == true ? 'block' :'hidden'" 
            >
            <ul className="py-2 text-sm dark:text-gray-200 ">
                <li>
                <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-800 dark:hover:text-white hover:bg-gray-100 flex gap-1 items-center border-b dark:border-zinc-700"> <FiCheck size={23} className="h-4 text-zinc-3000"/> <p>Mark</p> </a>
                </li>
                <li>
                <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-800 dark:hover:text-white hover:bg-gray-100 flex gap-1 items-center border-b dark:border-zinc-700"> <FiRepeat size={23} className="h-4 text-zinc-3000"/> <p>Forward</p> </a>
                </li>
                <li>
                <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-800 dark:hover:text-white hover:bg-gray-100 flex gap-1 items-center"> <FiTrash2 className="h-4 text-zinc-3000"/>  <p>Delete</p> </a>
                </li>                        
            </ul>
        </div>
        
        </div>   
        <div className="hidden group-hover:flex dark:bg-zinc-800 items-center absolute right-6 -top-5 bg-[#fcfcfc] p-1 cursor-pointer rounded-full shadow-md border border-white/20 flex gal-1 text-xl">
        <div onClick={()=>handle('👍',id)} className="hover:scale-125">👍</div>
        <div onClick={()=>handle('😍',id)} className="hover:scale-125">😍</div>
        <div onClick={()=>handle('😂',id)} className="hover:scale-125">😂</div>
        <div onClick={()=>handle('😲',id)} className="hover:scale-125">😲</div>
        <div onClick={()=>handle('😞',id)} className="hover:scale-125">😞</div>
        <div onClick={()=>handle('😡',id)} className="hover:scale-125">😡</div>
        <div onClick={()=>handle('👎',id)} className="hover:scale-125">👎</div>

            <EmojiPicker
              wrapper={ <div className="bg-gray-200 dark:bg-zinc-700 rounded-md mr-1 h-6 w-6 flex items-center justify-center"> <FiPlus className=" text-gray-500 h-5"/> </div>}
              right
            />
            
        </div>


    </div>
  )
}
  